// FORT-325: Staff Daily shift checklists.

export type ShiftBlock = "Opening" | "During" | "LockUp";

export const SHIFT_BLOCKS: ShiftBlock[] = ["Opening", "During", "LockUp"];

export const SHIFT_BLOCK_LABELS: Record<ShiftBlock, string> = {
  Opening: "Opening",
  During: "During the day",
  LockUp: "Lock-up",
};

// --- Staff Daily (today) view ---

export interface ChecklistItemState {
  itemId: number;
  label: string;
  position: number;
  isDone: boolean;
  completedByStaffName: string | null;
  completedAt: string | null;
}

export interface TodayShiftBlock {
  block: ShiftBlock;
  doneCount: number;
  totalCount: number;
  items: ChecklistItemState[];
}

export interface TodayShift {
  shiftDefinitionId: number;
  shiftName: string;
  startTime: string | null;
  endTime: string | null;
  isUrgent: boolean;
  blocks: TodayShiftBlock[];
}

// --- Settings editor (template config) ---

export interface ShiftConfigItem {
  id: number;
  block: ShiftBlock;
  label: string;
  position: number;
}

export interface ShiftConfigDefinition {
  id: number;
  name: string;
  startTime: string | null;
  endTime: string | null;
  position: number;
  isUrgent: boolean;
  items: ShiftConfigItem[];
}

// --- Replace-config payload ---

export interface ShiftItemPayload {
  id: number | null;
  block: ShiftBlock;
  label: string;
  position: number;
}

export interface ShiftConfigPayload {
  id: number | null;
  name: string;
  startTime: string | null;
  endTime: string | null;
  position: number;
  isUrgent: boolean;
  items: ShiftItemPayload[];
}

export interface ReplaceShiftConfigPayload {
  shifts: ShiftConfigPayload[];
}
